import { Box, HStack, Image, Text, useDisclosure } from '@chakra-ui/react';

import Plant from 'assets/brand/plant.png';
import SunshineIcon from 'components/_core/SunshineIcon';
import MultiWalletUpsellBadge from 'components/MultiWalletUpsellBadge';
import MultiWalletUpsellModal from 'components/MultiWalletUpsellModal';

import locales from './locales';

const MultiWalletUpsellCard = () => {
  const { isOpen, onClose, onOpen } = useDisclosure();

  return (
    <>
      <Box
        _hover={{
          borderColor: 'grey.400',
        }}
        borderColor="grey.300"
        borderRadius="radius-16"
        borderWidth="1px"
        overflow="hidden"
      >
        <HStack
          _hover={{
            backgroundColor: 'grey.100',
          }}
          as="button"
          onClick={onOpen}
          padding="space-16"
          spacing="space-16"
          width="full"
        >
          <Box height={64} position="relative" width={64}>
            <Box
              backgroundColor="blue.300"
              borderRadius="radius-16"
              boxSize="56px"
              left={8}
              opacity={0.4}
              position="absolute"
              top={8}
            />
            <Image
              alt=""
              backgroundColor="blue.300"
              borderRadius={14}
              boxSize="56px"
              left={0}
              position="absolute"
              role="presentation"
              src={Plant}
              top={0}
            />
          </Box>
          <Box flex={1} overflow="hidden">
            <Text
              color="grey.800"
              fontSize="font-18"
              fontWeight="weight-500"
              textAlign="left"
            >
              {locales.exploreWallets}
            </Text>
          </Box>
          <SunshineIcon color="grey.600" name="chevron-right" size="icon-24" />
        </HStack>
        <Box paddingBottom="space-16" paddingX="space-16">
          <MultiWalletUpsellBadge />
        </Box>
      </Box>
      {isOpen ? (
        <MultiWalletUpsellModal isOpen={isOpen} onClose={onClose} />
      ) : null}
    </>
  );
};

export default MultiWalletUpsellCard;
